module.exports = __webpack_public_path__ + "kerbin/app/images/signup/thank-you-person.4cff4b0b.jpg";